<template>
  <div class="crud-create-external-wrapper relative">
    <div
      class="admin-view-toolbar width-expand bg-bg z-level-2 margin-l-bottom padding-s-vertical"
      style="position: sticky; top: 0px; border-bottom: 1px solid var(--c-gray-1)">
      <div class="flex flex-between gap-s l:gap-l margin-l-bottom flex-wrap">
        <div class="start-side flex gap-s flex-wrap">
          <form-button
            icon="x"
            theme="danger"
            text="core.crud.createCancel"
            @click=" $router.push(successRedirect)"></form-button>
          <form-button
            icon="check"
            theme="success"
            text="core.crud.createSave"
            @click="save"></form-button>
        </div>
        <div class="end-side flex gap-s flex-wrap">
          <form-button
            icon="plus"
            theme="primary"
            text="core.crud.createAndNew"
            @click="saveAndNew"></form-button>

          <form-button
            icon="copy"
            type="primary"
            text="core.crud.createAndCopy"
            @click="saveAndCopy"></form-button>
        </div>
      </div>
    </div>

    <div class="crud-create-content">
      <base-form
        ref="createForm"
        v-model="item"
        :auto-set-default-values="true"
        :action="formAction"
        method="post"
        :form-path="formPath"
        :config="{ context: 'create', buttons: {} }"
        @form:ready="handleFormReady"
        @form:submit-success="afterSubmit"></base-form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    formPath: {
      type: String,
      default: false,
    },
    formAction: {
      type: String,
      default: false,
    },
    successRedirect: {
      type: Object,
      default: { name: "admin-dashboard" },
    },
  },
  data: function () {
    return {
      item: {},
    };
  },
  computed: {},
  methods: {
    handleFormReady(data) {
      return;
    },
    // successful submit handler
    afterSubmit: function (result) {
      this.$saffron.ui.notification("core.crud.createdSuccess", "success");
    },
    // save button - trigger submit. after normal submit action, if successfull, go back to list
    save: async function () {
      let result;

      try {
        result = await this.$refs.createForm.submit();
      } catch (e) {
        return;
      }

      if (!result || result.isError) {
        this.$s.ui.notification("core.genericError", "error");
      } else {
        this.$router.push(this.successRedirect);
      }
    },
    saveAndNew: async function () {
      let result;

      try {
        result = await this.$refs.createForm.handleSubmit();
      } catch (e) {
        return;
      }

      if (result && ! result.isError) {
        this.$refs.createForm.clear();
      }
    },
    saveAndCopy: async function () {
      let result;

      try {
        result = await this.$refs.createForm.handleSubmit();
      } catch (e) {
        return;
      }

      if (result && ! result.isError) {
        this.$saffron.ui.notification("core.crud.saveAndCopySuccess", "success");
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
